export default (application, element, controllerName) => {
  const getController = el => application.getControllerForElementAndIdentifier(el, controllerName);

  return new Promise((resolve) => {
    const controller = getController(element);

    if (controller) {
      resolve(controller);
      return;
    }

    // If the cart summary is not initialized yet, try again in a moment
    const interval = setInterval(() => {
      const controllerInInterval = getController(element);

      if (controllerInInterval) {
        resolve(controllerInInterval);
        clearInterval(interval);
      }
    }, 50);
  });
};
